/**
 * 交易時段
 */
export enum SessionType {
  TWSE = 0,
  TAIFEX = 1,
  TAIFEX_AM = 2,
}
